import React from "react";
import { Link } from "react-router-dom";

const Buttons = () => {
  return (
    <div className="w-full inline-flex justify-between px-5 xl:px-7 truncate">
      <div className="hidden md:inline-flex">
        <div className="w-56 h-10 px-4 py-3 inline-flex justify-center items-center border border-bodyColor border-solid border-opacity-20 rounded-lg">
          <span className="text-bodyColor text-opacity-60 text-sm font-Inter font-medium break-words">
            Current Market Size:
          </span>
          <span className="ml-2 text-bodyColor text-sm font-Inter font-medium break-words">
            $905K
          </span>
        </div>
        <div className="w-48 h-10 px-4 py-3 ml-1.5 inline-flex justify-center items-center border border-bodyColor border-solid border-opacity-20 rounded-lg">
          <span className="text-bodyColor text-opacity-60 text-sm font-Inter font-medium break-words">
            Total Borrowed:
          </span>
          <span className="ml-2 text-bodyColor text-sm font-Inter font-medium break-words">
            $905K
          </span>
        </div>
        <div className="w-36 h-10 px-4 py-3 ml-1.5 inline-flex justify-center items-center border border-bodyColor border-solid border-opacity-20 rounded-lg">
          <span className="text-bodyColor text-opacity-60 text-sm font-Inter font-medium break-words">
            Lent Out:
          </span>
          <span className="ml-2 text-bodyColor text-sm font-Inter font-medium break-words">
            15.2%
          </span>
        </div>
      </div>
      <Link to="/liquidate">
        <button
          type="button"
          className="w-24 h-10 px-4 py-3 inline-flex justify-center items-center bg-submitButtonColor text-tableBodyColor text-sm font-Outfit font-semibold break-words rounded-lg"
        >
          Liquidate
        </button>
      </Link>
    </div>
  );
};

export default Buttons;
